export const classicUrl = {
  Local: "https://dev-pendeltag.stockholmstag.sj.se", //change when needed
  Prod: "https://pendeltag.stockholmstag.sj.se",
  Test: "https://test-pendeltag.stockholmstag.sj.se",
  Dev: "https://dev-pendeltag.stockholmstag.sj.se",
};
